// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UIT9v","name":"styles_name__1tNiC","phone":"styles_phone__3n4fL"};